import { render, staticRenderFns } from "./Manufacturers.vue?vue&type=template&id=5216b00c"
import script from "./Manufacturers.vue?vue&type=script&lang=js"
export * from "./Manufacturers.vue?vue&type=script&lang=js"
import style0 from "./Manufacturers.vue?vue&type=style&index=0&id=5216b00c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports